// P111 on the web: the sidebar rebuild paces itself by its OWN cost (core/rebuildPacing.ts, twin of
// RebuildPacing.swift / .kt) and derives nothing while nothing is on screen.
//
// One rebuild = the worker's sidebar read (request → answer) + `buildSidebar` on the page. Both are
// timed into the same cycle; the next rebuild may start no sooner than max(cost, 150 ms floor) after
// the last one ended, capped at 2 s. A change that arrives while the tab is hidden only marks the
// list stale; the rebuild runs once when the tab is visible again. Small accounts are unaffected:
// their cost is a few ms, so the floor decides — the same 150 ms the natives coalesce by.
import { RebuildPacing } from '../core/rebuildPacing';

export class RebuildPacer {
  private cost = 0;
  private endedAt = Number.NEGATIVE_INFINITY;

  /** A rebuild cycle starts (the read is sent). */
  begin(): void {
    this.cost = 0;
  }

  /** Part of the current cycle took `ms` and finished at `now` (read answer, then the build). */
  add(ms: number, now: number): void {
    this.cost += Math.max(0, ms);
    this.endedAt = now;
  }

  /** The last full cycle's cost (ms). */
  get lastCostMs(): number {
    return this.cost;
  }

  /** How long to wait at `now` before the next rebuild may start (0 = at once). */
  waitMs(now: number): number {
    const delay = RebuildPacing.nextDelayNanos(this.cost * 1e6) / 1e6;
    return Math.max(0, this.endedAt + delay - now);
  }
}

/** The ONE pacer for the sidebar: the worker read (useLive) and the page build share it. */
export const sidebarPacer = new RebuildPacer();
